class BdProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('.bd-add-to-cart-form');
    this.button = this.querySelector('.bd-add-to-cart');

    if (!this.form || !this.button) {
      console.warn('[BD] Missing form or button inside bd-product-card');
      return;
    }

    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.button.disabled = true;
      this.button.classList.add('is-loading');
       this.classList.add('is-loading');
    } else {
      this.button.disabled = false;
      this.button.classList.remove('is-loading');
      this.classList.remove('is-loading');
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    this.setLoading(true);

    try {
      const formData = new FormData(this.form);

      // 1. Add to cart
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });

      const addedItem = await addRes.json();

      // 2. Fetch full cart JSON
      const cart = await fetch('/cart.js').then(r => r.json());

      // 3. Fetch cart sections HTML (Allure requires this)
      const sections = await fetch(
        window.location.pathname + '?sections=cart-drawer,cart-items&lazyload=false'
      ).then(r => r.json());

      // 4. Build the payload Allure expects
      const cartData = {
        ...cart,
        sections,
        params: []
      };

      // 5. Fire native theme event
      document.dispatchEvent(new CustomEvent('l:product:added', {
        detail: { cartData }
      }));

      // 6. Fire EventBus update event
      window.themeCore.EventBus.emit("cart:updated", cartData);

      // 7. Open drawer
      window.themeCore.EventBus.emit("cart:drawer:open");

    } catch (err) {
      console.error('[BD] Add to cart error:', err);
    } finally {
      this.setLoading(false);
    }
  }
}

customElements.define('bd-product-card', BdProductCard);
